import { required, useNotify, useRefresh } from "react-admin";
import Edit from "@mui/icons-material/Edit";
import { Grid, Button } from "@mui/material";
import ProfessorInput from "server/components/Fields/ProfessorInput";
import { getUser } from "auth/security/securityUtils";
import { studentRequests } from "api/studentApi";
import CustomDateInput from "server/components/Fields/CustomDateInput";
import useConflictErrorModal from "server/components/Modals/useConflictErrorModal";
import FormModal from "server/components/Modals/FormModal";
import dataProvider from "server/dataProvider";
import { useNotifyError } from "utils/useNotifyError";

const SubstituteProfessorModal = ({ record }) => {
  const { handleConflictError, ConflictErrorDialog } = useConflictErrorModal();
  const notifyError = useNotifyError();
  const notify = useNotify();
  const refresh = useRefresh();

  const formattedDate = record?.start ? new Date(record?.start).toISOString().split("T")[0] : null;
  const employeeId = JSON.parse(getUser()).employeeId;

  const handleSent = async data => {
    const payload = {
      substituteEmployeeId: data.substituteEmployeeId,
      scheduleDate: formattedDate,
    };

    try {
      await dataProvider.customRequest(
        studentRequests.createWeeklyScheduleProfessorSubstitution(record.id),
        payload,
        "POST",
      );
      refresh();
      notify("Успешно пусната заявка за заместник", { type: "success" });
    } catch (e) {
      notifyError(e);
      handleConflictError(e);
    }
  };

  return (
    <>
      <FormModal
        titleContent="Избери заместник"
        onConfirm={handleSent}
        defaultValues={{ scheduleDate: formattedDate }}
        triggerButton={
          <Button
            variant="contained"
            startIcon={<Edit />}
            label="Избери заместник"
            size="medium"
          />
        }
      >
        <Grid
          container
          spacing={2}
        >
          <Grid
            item
            xs={12}
          >
            <ProfessorInput
              validate={required()}
              source="substituteEmployeeId"
              filters={{ DisciplineId: record.disciplineId, ExcludeIds: [employeeId] }}
              fullWidth
            />
          </Grid>
          <Grid
            item
            xs={12}
          >
            <CustomDateInput
              source="scheduleDate"
              label="Дата"
              noTime
              required={true}
              disabled
            />
          </Grid>
        </Grid>
      </FormModal>
      <ConflictErrorDialog />
    </>
  );
};

export default SubstituteProfessorModal;
